import { useEffect } from 'react';
import { useTrackingState } from './TrackingStateContext';
import { DisplayedAttribute } from './types';

export default function useRegisterDisplayedAttribute(
  unitId: string | undefined,
  attr: DisplayedAttribute,
) {
  const { registerDisplayedAttribute } = useTrackingState();

  useEffect(() => {
    if (unitId) {
      registerDisplayedAttribute(unitId, attr);
    }
  }, [attr, registerDisplayedAttribute, unitId]);
}
